const info = 
{
    title: "My Head",
    type: "Short Film"
};

export default info;